import { FC } from 'react';

import { ReportComponent } from '@/types';

import ChartFormatting, { hasChartFormattingControls } from './components/ChartFormatting';

interface FormattingProps {
    component: ReportComponent;
}

const Formatting: FC<FormattingProps> = ({ component }): JSX.Element => {
    if (!hasChartFormattingControls(component.type)) {
        return <></>;
    }

    return (
        <>
            <div style={{ padding: '0 1rem' }}>
                <ChartFormatting component={component} />
            </div>
        </>
    );
};

export default Formatting;
